; (function (root, factory) {
    // UMD/AMDWeb module bolierplate: https://github.com/umdjs/umd/blob/master/templates/amdWeb.js
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('FavouriteButton', [], factory);
    } else {
        // Browser globals
        root.FavouriteButton = factory();
    }
}(typeof self !== 'undefined' ? self : this, function (Hammer) {
    'use strict';

    function Favourite(element) {
        this.container = element;
        this.href = this.container.href;

        this.onclick = this.onclick.bind(this);
        this.onload = this.onload.bind(this);
        this.onerror = this.onerror.bind(this);
        this.ondata = this.ondata.bind(this);
        this.container.addEventListener('click', this.onclick);
    }

    Favourite.prototype = {
        onclick: function (event) {
            event.preventDefault();
            if (this.container.classList.contains('-loading')) return;
            this.href = this.container.href;
            this.container.classList.add('-loading');

            var self = this;
            this._promiseAnimation = new Promise(function (resolve, reject) {
                self.container.addEventListener('animationend', resolve);
            });

            var data = new FormData();
            var inputs = this.container.querySelectorAll('input[type="hidden"]');
            Array.prototype.forEach.apply(inputs, [function (el) {
                data.append(el.name, el.value);
            }]);

            var settings = {
                method: 'POST',
                credentials: 'include',
                body: data
            }

            Promise.all([
                this._promiseAnimation,
                fetch(this.href, settings)

            ]).then(this.onload).then(this.ondata).catch(this.onerror);
        },
        onload: function (data) {
            var response = data[1];
            return response.json();
        },
        ondata: function (result) {
            delete this._promiseAnimation;
            this.container.classList.remove('-loading');

            if (result.Success) {
                this.container.classList.toggle('-added');
                this.container.href = result.Href;
            }
        },
        onerror: function (error) {
            this.container.classList.remove('-loading');
            console.warn(error);
        }
    }

    return Favourite;
}));